import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import Router from './router';
import appStyles from './App.scss?inline';
import { CallCenterProvider } from './providers/CallCenterProvider';
import { getCorpCode, getRootElement } from './util/Application';
import { Provider } from 'react-redux';
import store from './api';
import DebugBar from './components/DebugBar';
import { PortalTargetProvider } from './util/PortalTarget';

const corpCode = getCorpCode();
const hostElement = getRootElement() as HTMLElement;

// Shadow DOM isolates our own chrome from the host page's theme CSS (and
// vice versa) — but the JBL/SUL booking widgets Root renders via <Outlet/>
// are separate apps that inject their own CSS into document.head and look
// themselves up via plain document.getElementById(), neither of which works
// across a shadow boundary. Root.tsx portals that content back out here.
const lightDomPortalTarget = document.createElement('div');
hostElement.insertAdjacentElement('afterend', lightDomPortalTarget);

const shadowRoot = hostElement.attachShadow({ mode: 'open' });

const styleTag = document.createElement('style');
styleTag.textContent = appStyles;
shadowRoot.appendChild(styleTag);

const mountPoint = document.createElement('div');
shadowRoot.appendChild(mountPoint);

const root = ReactDOM.createRoot(mountPoint);

if (!corpCode) {
    root.render(
        <>
            <DebugBar />
            <span className='my-12 flex items-center justify-center text-3xl font-bold text-red-600'>
                Missing required &quot;corp&quot; parameter — add ?corp=CODE to the URL.
            </span>
        </>
    );
} else {
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <CallCenterProvider corpCode={corpCode}>
                    <PortalTargetProvider value={lightDomPortalTarget}>
                        <DebugBar />
                        <RouterProvider router={Router} />
                    </PortalTargetProvider>
                </CallCenterProvider>
            </Provider>
        </React.StrictMode>
    );
}
